import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false, managerOnly = false }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: `${loc.pathname}${loc.search}` }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (managerOnly && user.role !== "admin" && !user.sales_manager) return <Navigate to="/" replace />;
  return children;
}
